/**
 * @generated SignedSource<<bf7ecd7415ae9a0f1120b83430e74429>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ListFocusScrollSubscription$variables = {
  widgetId: string;
};
export type ListFocusScrollSubscription$data = {
  readonly widgetFocusScrollChanged: string;
};
export type ListFocusScrollSubscription = {
  response: ListFocusScrollSubscription$data;
  variables: ListFocusScrollSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "widgetId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "widgetId",
        "variableName": "widgetId"
      }
    ],
    "kind": "ScalarField",
    "name": "widgetFocusScrollChanged",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ListFocusScrollSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ListFocusScrollSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8bc22bfa33cdeb3f5e4f2e1924214a3e",
    "id": null,
    "metadata": {},
    "name": "ListFocusScrollSubscription",
    "operationKind": "subscription",
    "text": "subscription ListFocusScrollSubscription(\n  $widgetId: ID!\n) {\n  widgetFocusScrollChanged(widgetId: $widgetId)\n}\n"
  }
};
})();

(node as any).hash = "a6c166bea9c4c2cea6f55b44c6c1d617";

export default node;
